(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/common/assets/javascripts/flag-mapping.js') >= 0) return;  svs.modules.push('/components/oddset/common/assets/javascripts/flag-mapping.js');
"use strict";


const FlagMap = {
  afghanistan: 'afg',
  albanien: 'alb',
  algeriet: 'dza',
  'amerikanska jungfruöarna': 'vir',
  'amerikanska samoa': 'asm',
  andorra: 'and',
  angola: 'ago',
  anguilla: 'aia',
  antarktis: 'ata',
  'antigua och barbuda': 'atg',
  argentina: 'arg',
  armenien: 'arm',
  aruba: 'abw',
  australien: 'aus',
  azerbajdzjan: 'aze',
  bahamas: 'bhs',
  bahrain: 'bhr',
  bangladesh: 'bgd',
  barbados: 'brb',
  belarus: 'blr',
  belgien: 'bel',
  belize: 'blz',
  benin: 'ben',
  bermuda: 'bmu',
  bhutan: 'btn',
  bolivia: 'bol',
  bonaire: 'bes',
  'bosnien-hercegovina': 'bih',
  botswana: 'bwa',
  bouvetön: 'bvt',
  brasilien: 'bra',
  'brittiska jungfruöarna': 'vgb',
  'brittiska territoriet i indiska oceanen': 'iot',
  brunei: 'brn',
  bulgarien: 'bgr',
  'burkina faso': 'bfa',
  burundi: 'bdi',
  caymanöarna: 'cym',
  'centralafrikanska republiken': 'caf',
  chile: 'chl',
  colombia: 'col',
  cooköarna: 'cok',
  'costa rica': 'cri',
  curacao: 'cuw',
  cypern: 'cyp',
  danmark: 'dnk',
  djibouti: 'dji',
  dominica: 'dma',
  'dominikanska republiken': 'dom',
  'dr kongo': 'cod',
  ecuador: 'ecu',
  egypten: 'egy',
  ekvatorialguinea: 'gnq',
  'el salvador': 'slv',
  elfenbenskusten: 'civ',
  england: 'eng',
  eritrea: 'eri',
  estland: 'est',
  eswatini: 'swz',
  etiopien: 'eth',
  falklandsöarna: 'flk',
  fiji: 'fji',
  filippinerna: 'phl',
  finland: 'fin',
  frankrike: 'fra',
  'franska guyana': 'guf',
  'franska polynesien': 'pyf',
  'franska sydterritorierna': 'atf',
  färöarna: 'fro',
  'förenade arabemiraten': 'are',
  gabon: 'gab',
  gambia: 'gmb',
  georgien: 'geo',
  ghana: 'gha',
  gibraltar: 'gib',
  grekland: 'grc',
  grenada: 'grd',
  grönland: 'grl',
  guadeloupe: 'glp',
  guam: 'gum',
  guatemala: 'gtm',
  guernsey: 'ggy',
  guinea: 'gin',
  'guinea-bissau': 'gnb',
  guyana: 'guy',
  haiti: 'hti',
  'heard- och mcdonaldöarna': 'hmd',
  honduras: 'hnd',
  hongkong: 'hkg',
  indien: 'ind',
  indonesien: 'idn',
  irak: 'irq',
  iran: 'irn',
  irland: 'irl',
  island: 'isl',
  'isle of man': 'imn',
  israel: 'isr',
  italien: 'ita',
  jamaica: 'jam',
  japan: 'jpn',
  jemen: 'yem',
  jersey: 'jey',
  jordanien: 'jor',
  julön: 'cxr',
  kambodja: 'khm',
  kamerun: 'cmr',
  kanada: 'can',
  'kap verde': 'cpv',
  katalonien: 'es-ct',
  kazakstan: 'kaz',
  kenya: 'ken',
  kina: 'chn',
  kirgizistan: 'kgz',
  kiribati: 'kir',
  kokosöarna: 'cck',
  komorerna: 'com',
  kongo: 'cog',
  kosovo: 'xxk',
  kroatien: 'hrv',
  kuba: 'cub',
  kuwait: 'kwt',
  laos: 'lao',
  lesotho: 'lso',
  lettland: 'lva',
  libanon: 'lbn',
  liberia: 'lbr',
  libyen: 'lby',
  liechtenstein: 'lie',
  litauen: 'ltu',
  luxemburg: 'lux',
  macao: 'mac',
  madagaskar: 'mdg',
  malawi: 'mwi',
  malaysia: 'mys',
  maldiverna: 'mdv',
  mali: 'mli',
  malta: 'mlt',
  marocko: 'mar',
  marshallöarna: 'mhl',
  martinique: 'mtq',
  mauretanien: 'mrt',
  mauritius: 'mus',
  mayotte: 'myt',
  mexiko: 'mex',
  mikronesien: 'fsm',
  moldavien: 'mda',
  monaco: 'mco',
  mongoliet: 'mng',
  montenegro: 'mne',
  montserrat: 'msr',
  moçambique: 'moz',
  myanmar: 'mmr',
  namibia: 'nam',
  nauru: 'nru',
  nederländerna: 'nld',
  nepal: 'npl',
  nicaragua: 'nic',
  niger: 'ner',
  nigeria: 'nga',
  niue: 'niu',
  nordirland: 'nir',
  nordkorea: 'prk',
  nordmakedonien: 'mkd',
  nordmarianerna: 'mnp',
  norfolkön: 'nfk',
  norge: 'nor',
  'nya kaledonien': 'ncl',
  'nya zeeland': 'nzl',
  oman: 'omn',
  pakistan: 'pak',
  palau: 'plw',
  palestina: 'pse',
  panama: 'pan',
  'papua nya guinea': 'png',
  paraguay: 'pry',
  peru: 'per',
  pitcairnöarna: 'pcn',
  polen: 'pol',
  portugal: 'prt',
  'puerto rico': 'pri',
  qatar: 'qat',
  rumänien: 'rou',
  rwanda: 'rwa',
  ryssland: 'rus',
  réunion: 'reu',
  'saint barthélemy': 'blm',
  'saint kitts och nevis': 'kna',
  'saint lucia': 'lca',
  'saint martin': 'maf',
  'saint vincent och grenadinerna': 'vct',
  'saint-pierre och miquelon': 'spm',
  salomonöarna: 'slb',
  samoa: 'wsm',
  'san marino': 'smr',
  'sankta helena': 'shn',
  saudiarabien: 'sau',
  schweiz: 'che',
  senegal: 'sen',
  serbien: 'srb',
  seychellerna: 'syc',
  'sierra leone': 'sle',
  singapore: 'sgp',
  'sint maarten': 'sxm',
  skottland: 'sco',
  slovakien: 'svk',
  slovenien: 'svn',
  somalia: 'som',
  spanien: 'esp',
  'sri lanka': 'lka',
  storbritannien: 'gbr',
  sudan: 'sdn',
  surinam: 'sur',
  'svalbard och jan mayen': 'sjm',
  sverige: 'swe',
  sydafrika: 'zaf',
  'sydgeorgien och sydsandwichöarna': 'sgs',
  sydkorea: 'kor',
  sydsudan: 'ssd',
  syrien: 'syr',
  'são tomé och príncipe': 'stp',
  taiwan: 'twn',
  tadzjikistan: 'tjk',
  tanzania: 'tza',
  tchad: 'tcd',
  thailand: 'tha',
  tjeckien: 'cze',
  togo: 'tgo',
  tokelau: 'tkl',
  tonga: 'ton',
  'trinidad och tobago': 'tto',
  tunisien: 'tun',
  turkiet: 'tur',
  turkmenistan: 'tkm',
  'turks- och caicosöarna': 'tca',
  tuvalu: 'tuv',
  tyskland: 'deu',
  uganda: 'uga',
  ukraina: 'ukr',
  ungern: 'hun',
  uruguay: 'ury',
  usa: 'usa',
  'usa:s yttre öar': 'umi',
  uzbekistan: 'uzb',
  vanuatu: 'vut',
  vatikanstaten: 'vat',
  venezuela: 'ven',
  vietnam: 'vnm',
  wales: 'wal',
  'wallis och futuna': 'wlf',
  västsahara: 'esh',
  zambia: 'zmb',
  zimbabwe: 'zwe',
  åland: 'ala',
  österrike: 'aut',
  östtimor: 'tls'
};
const toExport = {
  FlagMap
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.oddset.common.flagMapping', toExport);
}

 })(window);